var _excluded = ["gutter", "placement"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { usePopoverState } from "reakit";
import * as React from "react";
export function useSelectPopoverState(select) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      {
    gutter = 0,
    placement = "bottom-start"
  } = _ref,
      initialState = _objectWithoutProperties(_ref, _excluded);

  var {
    move,
    reset,
    selectedId
  } = select;
  var popover = usePopoverState(_objectSpread({
    gutter,
    placement
  }, initialState));
  var visible = popover.visible;
  React.useEffect(() => {
    if (visible && selectedId) move === null || move === void 0 ? void 0 : move(selectedId); // We need to reset select.moves

    if (!visible) reset();
  }, [visible, reset, selectedId, move]);
  return _objectSpread(_objectSpread(_objectSpread({}, select), popover), {}, {
    visible
  });
}
//# sourceMappingURL=SelectPopoverState.js.map